import { IListElementCellBase } from './list-element-cell-base.interface';
import { IListElementCell } from './list-element-cell.interface';

import { ILink } from '../../link.interface';

export interface IListElementLinkCell
  extends IListElementCellBase,
    Pick<ILink, '$internal' | '$newtab' | '$sametab' | '$target'> {
  /** Link icon name */
  $icon?: string;
  /** Link icon place */
  $icon_side?: 'left' | 'right';
  /** Link name. Used to get link caption */
  $name: string;
}

/**
 * Check cell on link type
 *
 * @param cell
 */
export function isLinkCell(
  cell: IListElementCell,
): cell is IListElementLinkCell {
  return '$name' in cell;
}
